import { Route } from '@angular/router';
import { SharedResourceRootFileResolver } from './files.resolvers';
import { SharedResourcesSharedResourceResolver } from 'app/modules/shared-resources/shared-resources.resolvers';
import { SharedResourceFilesComponent } from './files.component';
import { SharedResourceFileDetailsComponent } from './details/details.component';

export const filesRoutes: Route[] = [
  {
    path: ':token',
    component: SharedResourceFilesComponent,
    resolve: {
      sharedResource: SharedResourcesSharedResourceResolver,
    },
    children: [
      {
        path: '',
        component: SharedResourceFileDetailsComponent,
        resolve: {
          file: SharedResourceRootFileResolver,
        },
      },
      {
        path: ':id',
        component: SharedResourceFileDetailsComponent,
        resolve: {
          file: SharedResourceRootFileResolver,
        },
      },
    ],
  },
];
